/* eslint-disable react-hooks/exhaustive-deps */
import { RouteName } from "constant/routeNames";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setChannelCategory } from "redux/VideoPlayerRedux";
import LiveTVService from "services/liveTv/LiveTVService";

function LiveTVGenreSelector({ category, setCategory, page }: any) {
  const [categories, setCategories] = useState<any[]>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (page) {
      navigate(RouteName.SeeAllChannelsRoute.replace(":slug", category));
    }
  }, [category]);

  useEffect(() => {
    LiveTVService.getLiveTvCategories()
      .then((res) => {
        setCategories(res.tv_channel_categories);
      })
      .catch((e) => {});
  }, []);

  const onChange = (e: any) => {
    setCategory(e.target.value);
    dispatch(setChannelCategory(e.target.value));
  };

  return (
    <div className="flex items-center gap-2 max-sm:w-full">
      <label
        htmlFor="cars"
        className="text-sm text-white/60 max-md:hidden"
      >
        Category
      </label>
      <div className="relative max-sm:w-full">
        <select
          name="cars"
          id="cars"
          className="cursor-pointer appearance-none rounded-full border border-white/15 bg-white/5 py-2 pl-4 pr-10 text-sm text-white outline-none transition-colors hover:border-white/30 focus:border-white/40 max-sm:w-full"
          onChange={onChange}
          value={category}
        >
          <option value={"all"} className="bg-[#1a1a1d] text-white">
            All
          </option>
          {categories?.map((c: any, i) => (
            <option value={c.slug} key={i} className="bg-[#1a1a1d] text-white">
              {c.name}
            </option>
          ))}
        </select>
        {/* chevron */}
        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-white/50">
          <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </span>
      </div>
    </div>
  );
}

export default LiveTVGenreSelector;